import { CardSelect } from "@/components/Cards/components/CardSelect"
import { TransactionsCardList } from "@/components/Transactions/Card/List"
import { selectUser, useCardList, useCardView, useStoreClient } from "@usher/pe-client-front-end-lib"
import { Redirect, useHistory, useLocation, useParams } from "react-router-dom"

type Props = {
  isOrders?: boolean
}

export const TransactionsCard = ({ isOrders }: Props) => {
  const history = useHistory()
  const { id } = useParams<{ id?: string }>()
  const isAll = id == null
  const { pathname } = useLocation()
  const isCardDetailsTransactions = /cards\/\d+\/transactions/i.test(pathname)
  const { card_active } = useStoreClient(selectUser)
  const { cards } = useCardList()
  const { card } = useCardView(id)
  const isPayotType = card?.type === "3"
  if (!card_active) return <Redirect to="/transactions/exchange" />
  return (
    <div className="d-flex flex-column">
      {!isCardDetailsTransactions && (
        <div className="bg-white p-6 border mb-10">
          <h1 className="text-lg text-main-main font-bold">Please choose a card</h1>
          <div className="max-w-[50%] mt-2">
            <CardSelect
              withAllOption
              cards={cards}
              value={id ? String(id) : "All"}
              onChange={(option) => {
                const cardId = option?.value
                let path = `/transactions/card`
                if (cardId && isAll) path += `/${cardId}`
                history.push(path)
              }}
            />
          </div>
        </div>
      )}
      {isOrders && !isPayotType && <TransactionsCardList isOrders={isOrders} isCard={!isAll} />}
      <TransactionsCardList isOrders={isOrders} isCard={isAll} />
    </div>
  )
}
